export default {
  /*集团用户获取名下的门店*/
  UPDATESTORELISTS (state,lists) { state.StoreLists = {...state.StoreLists,...lists}; },
  /*更新当前查看门店信息，非集团用户登录时就初始化当前用户为当前门店*/
  UPDATECURRENTSTORE (state,storeInfo) { if(storeInfo=='clear'){state.currentStoreInfo ={}}else{state.currentStoreInfo = {...state.currentStoreInfo,...storeInfo}}},
  /*更新门店基本信息*/
  UPDATESTOREBASIC (state,storeBasic) { state.StoreBasicInfo = storeBasic; },
  /*更新门店编辑认证信息*/
  INFORMATINNTEXT(state,lists) { state.Informationtext = lists;},
  /*更新门店房间列表*/
  UPDATEROOMLISTS (state,lists) { state.StoreRoomArr = {...state.StoreRoomArr,...lists}},
  /*更新门店会议室列表*/
  UPDATEMEETLISTS (state,lists) { state.StoreMeetArr = {...state.StoreMeetArr,...lists}},
  /*更新房间会议室详情*/
  UPDATEROOMMEETDETAIL (state,info) { state.RoomMeetDetail = info; },
  /*更新门店资金信息*/
  UPDATEMONEYINFO (state,moneyInfo) { state.StoreMoneyInfo = {...state.StoreMoneyInfo,...moneyInfo}; },
  /*更新门店资金列表*/
  UPDATEMONEYLISTS (state,moneyLists) { state.StoreMoneyList = {...state.StoreMoneyList,...moneyLists}; },
  /*更新门店银行卡列表*/
  UPDATEBANKCARDLISTS (state,bankcardLists) { state.StoreBankcardList = {...state.StoreBankcardList,...bankcardLists}; },
  /*更新门店客房日历*/
  UPDATECALENDAR (state,lists) { state.StoreCalendar = lists; },
  /*更新门店发票列表*/
  UPDATEINVOICELISTS(state,lists) { state.StoreInvoiceLists = {...state.StoreInvoiceLists,...lists}; },
  /*更新门店促销活动列表*/
  UPDATEDISCOUNTLISTS(state,lists) { state.StoreDiscountLists = {...state.StoreDiscountLists,...lists}; },
  /*更新某一条促销活动详情*/
  UPDATEDISCOUNTDETAIL (state,info) { state.discountDetail = {...state.discountDetail,...info}; },
  /*更新门店银行卡列表*/
  UPDATETICKETLISTS (state,Lists) { state.StoreTicketList = {...state.StoreTicketList,...Lists}; },
  UPDATEATERYELISTS (state,Lists) { state.StoreEateryList = {...state.StoreEateryList,...Lists}; },
  /*更新某一条门票信息详情*/
  UPDATETICKETDETAIL (state,info) { state.ticketDetail = {...state.ticketDetail,...info}; },
  /*更新管理员查看的一些数据项列表*/
  UPDATEADMINDATALIST(state,Lists) { state.AdminDataLists = {...state.AdminDataLists,...Lists};},
  /*更新管理员查看的数据列表项的某一项详情*/
  UPDATEADMINITEMDETAIL(state,info) { state.AdminDataDetail = info },
  /*更新用户查看的统计报表*/
  UPDATECHARTLIST(state,Lists) { state.StoreChartLists = Lists },
  /*更新用户查看的报表详情数组*/
  UPDATECHARTDETAIL(state,Lists) { state.StoreChartDetail = {...state.StoreChartDetail,...Lists}; },
  /*更新用户查看的评论列表*/
  UPDATECOMMENTLISTS(state,Lists) { state.CommentLists = {...state.CommentLists,...Lists}; },
  /*更新用户查看的评论详情*/
  UPDATECOMMENTDETAIL(state,info) { state.CommentDetail = info; },
  /*更新用户收藏列表*/
  UPDATECOLLECTLISTS(state,Lists) { state.CollectList = {...state.CollectList,...Lists}; },
  /*获取门店的积分明细列表*/
  UPDATECREDITLIST(state,Lists) { state.CreditList = {...state.CreditList,...Lists}; },
  /*更新用户提现明细*/
  UPDATEWITHDRAWDETAIL(state,info) { state.withdrawDetail = info },
  /*用户返利信息*/
  UPDATEREBATEINFO(state,rebateInfo) { state.RebateInfo = rebateInfo },
}
